import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { SegovPage } from 'src/app/app.routes';
import { TransferirDadosParaEdicaoDoDiaParams } from 'src/app/domain/routeParamsModels/transferir-dados-para-edicao-do-dia.params';

@Component({
  selector: 'app-menu-reportagens',
  standalone: true,
  imports: [],
  templateUrl: './menu-reportagens.component.html',
  styleUrl: './menu-reportagens.component.css'
})
export class MenuReportagensComponent implements OnInit, OnDestroy {

  constructor(private readonly router : Router){

  }

  @Input() menusReportagem?: MenuItemReportagem[];
  @Input() menuReportagemSelectedItemOnStartInput?: EventEmitter<string>;

  @Output() dadosBotaoOutput = new EventEmitter<Reportagem>();
  @Output() topicoOutput = new EventEmitter<string>();

  selectedMenuReportagem?: MenuItemReportagem | null = null;
  ngOnInit(): void {
    if (this.menuReportagemSelectedItemOnStartInput) {
      this.menuReportagemSelectedItemOnStartInput.subscribe(texto => {
        this.selectedMenuReportagem = this.menusReportagem && texto ? this.menusReportagem.find(x => x.topic == texto) : null;
      })
    }
  }

  ngOnDestroy(): void {
    if (this.menuReportagemSelectedItemOnStartInput)
      this.menuReportagemSelectedItemOnStartInput.unsubscribe();
  }
 
  selectTopic(topicName: string) {
    this.topicoOutput.emit(topicName);
    
    if (this.menusReportagem) {
      const selected = this.menusReportagem
        .find(x => x.topic === topicName) || null;
      if (selected === this.selectedMenuReportagem && window.innerWidth < 993)
        this.selectedMenuReportagem = null;
      else
        this.selectedMenuReportagem = selected;
    }    
  }
  
  public emitButtonClick($event: Reportagem) {
    let dadosJornal: TransferirDadosParaEdicaoDoDiaParams;

    if ($event.idJornal === 0) {
      dadosJornal = {
        dataPublicacaoSelecionada: $event.dataPublicacao,
        nomeArquivo: $event.nomeArquivoPdf,
        paginaSelecionada: $event.pagina,
      };
    }
    else {
      dadosJornal = {
        dataPublicacaoSelecionada: $event.dataPublicacao,
        idCadernoEdicaoSelecionado: $event.idJornal,
        paginaSelecionada: $event.pagina,
      };
    }

    const link =  this.router.serializeUrl(this.router.createUrlTree([SegovPage.EdicaoDoDia], {queryParams: {dados: JSON.stringify(dadosJornal)}}))
    window.open(link, '_blank')
  }   
}

export interface MenuItemReportagem {
  topic: string;
  reportagens: Reportagem[];
}

export interface Reportagem {
  dataPublicacaoFormatada: string;
  dataPublicacao: Date;
  titulo: string;
  idJornal: number;
  pagina: number;
  nomeArquivoPdf?: string;
}